import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import { NotFound, RouteWithSubRoutes } from '@cordata/buffet';
import { SideNav } from '~/components/common';
import { TSideNavItem } from './SideNav/types';

interface PageLayoutProps {
  routes: {
    path: string;
  }[];
  sideNavItems: TSideNavItem[];
  children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  routes,
  sideNavItems,
  children,
}) => {
  const { path, url } = useRouteMatch();

  const redirectPath = sideNavItems.length > 0 ? (typeof sideNavItems[0] === 'string' ? `${path}/${sideNavItems[0]}` : (sideNavItems[0].to || sideNavItems[0].href)) : path;

  return (
    <Row>
      <Col
        md={2}
        className="left-container px-0"
      >
        <SideNav items={sideNavItems} />
      </Col>

      <Col
        md={10}
        className="overflow-auto mt-2"
        style={{ height: 'calc(100vh - 56px - 0.5rem)' }}
      >
        {children ? (
          <>
            {children}
          </>
        ) : (
          <Switch>
            <Route
              exact
              path={url}
              render={() => <Redirect to={redirectPath} />}
            />

            {routes.map(r => (
              <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
            ))}

            <Route path="*"><NotFound isRoute /></Route>
          </Switch>
        )}
      </Col>
    </Row>
  );
};

export default PageLayout;
